export const vertexShader = `
precision highp float;
varying vec2 vuv;

void main() {
	vuv = uv;

	gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`;

export const fragmentShader = `
precision highp float;
uniform sampler2D texture;
varying vec2 vuv;
void main() {

	vec2 colorVuv = vec2(vuv.x, (vuv.y / 2.0) + 0.5);
	vec2 alphaVuv = vec2(vuv.x, (vuv.y / 2.0));
	vec3 textColor = texture2D(texture, colorVuv).rgb;
	vec3 textAlpha = texture2D(texture, alphaVuv).rgb;
	vec3 outColor = vec3(
		textColor.x,
		textColor.y,
		textColor.z
	);
	gl_FragColor = vec4(outColor, textAlpha.x);
}
`;
